import { Stack } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
// redux
import { useDispatch, useSelector } from "../../../redux/store";
import { setSimilarCreatorDetails } from "../../../redux/slices/creator";
// config
import colors from "../../../config/colors";
// components
import { ProfileInfo, Tabs } from "../../../components/Discover/details";
// tabs
import ContentTab from "./ContentTab";
import OverviewTab from "./OverviewTab";

const SimiliarCreatorDetails = () => {
  const dispatch = useDispatch();
  const similarCreatorDetails = useSelector(
    (state) => state.creator.similarCreatorDetails,
  );
  const selectedTab = useSelector(
    (state) => state.creator.selectedSimilarCreatorDetailsTab,
  );

  const handleCloseDrawer = () => {
    dispatch(setSimilarCreatorDetails(null));
  };
  return (
    <Stack
      sx={{
        padding: "24px",
        backgroundColor: colors.primary100,
        gap: "24px",
      }}
    >
      <Stack
        direction={"row"}
        alignItems={"center"}
        justifyContent="space-between"
      >
        <KeyboardBackspaceIcon
          sx={{ cursor: "pointer" }}
          onClick={handleCloseDrawer}
        />
        <CloseIcon sx={{ cursor: "pointer" }} onClick={handleCloseDrawer} />
      </Stack>
      <ProfileInfo item={similarCreatorDetails} />
      <Tabs type="similarCreatorDetails" />
      {selectedTab === "overview" && (
        <OverviewTab details={similarCreatorDetails} />
      )}
      {selectedTab === "content" && (
        <ContentTab
          wishlink_username={similarCreatorDetails?.wishlink_username}
        />
      )}
    </Stack>
  );
};

export default SimiliarCreatorDetails;
